'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/7/3.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServicesModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'productDetailServicesPackaging',
  fields: ['services']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServicesModal, _Component);

  function ServicesModal() {
    (0, _classCallCheck3.default)(this, ServicesModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServicesModal).call(this));

    _this.state = {
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(ServicesModal, [{
    key: 'onCheckChanged',
    value: function onCheckChanged(services, value) {
      var servicesArray = [];
      if (typeof services.value === 'string' && services.value !== '') {
        servicesArray = services.value.split(',');
      }
      if (servicesArray.indexOf(value) >= 0) {
        var valuesCopy = [].concat((0, _toConsumableArray3.default)(servicesArray));
        var valueIndex = servicesArray.indexOf(value);

        valuesCopy.splice(valueIndex, 1);
        services.onChange(valuesCopy.join(','));
      } else {
        services.onChange(servicesArray.concat(value).join(','));
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ServicesModal.scss');
      var _props = this.props;
      var services = _props.fields.services;
      var servicesData = _props.servicesData;
      var handleSubmit = _props.handleSubmit;
      var onClose = _props.onClose;
      var isOpened = _props.isOpened;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '80rem',
          maxWidth: '80rem'
        }
      };
      var closeHover = this.state.closeHover;

      var hoverClassName = styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.zhuan;
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.close },
          _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'form',
          { className: styles.component },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              '服务'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalContent },
            servicesData instanceof Array ? servicesData.map(function (service, index) {
              return _react2.default.createElement(
                'div',
                { key: index, className: styles.item },
                _react2.default.createElement('img', { className: styles.checkbox,
                  src: typeof services.value === 'string' && services.value.split(',').indexOf(service.id) >= 0 ? 'http://tupian.goeasy.cn:9999/yipinwang/per_center/rad_hover.png' : 'http://tupian.goeasy.cn:9999/yipinwang/per_center/rad.png',
                  onClick: function onClick() {
                    return _this2.onCheckChanged(services, service.id);
                  } }),
                service.name + ' 价格：' + service.price
              );
            }) : ''
          ),
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement(_SubmitBtn2.default, { btnClick: handleSubmit, text: '确定' }),
        _react2.default.createElement(_SubmitBtn2.default, { btnClick: onClose, text: '关闭' }),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ServicesModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  isOpened: _react.PropTypes.bool,
  closeHover: _react.PropTypes.bool,
  servicesData: _react.PropTypes.array,
  onClose: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ServicesModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServicesModal/ServicesModal.js
 ** module id = 1424
 ** module chunks = 0
 **/